//@MUI
import {
  Box,
  Checkbox,
  Chip,
  FormControl,
  MenuItem,
  Select,
  TableCell,
  Tooltip,
  Typography,
} from "@mui/material";
//@Components
import { fpatch } from "../../../API/callsAPI";
import DateAndTimeViewer from "../../Utilities/DateAndTimeViewer/DateAndTimeViewer.component";
import ImageViewer from "../../Utilities/ImageViewer/ImageViewer.component";
import Img from "../no-thumbnail.png";
import StatusDropDown from "../StatusDropDown/StatusDropDown.component";
import TaskDetailsOnHover from "../TaskDetailsOnHover/TaskDetailsOnHover";
import useStyles from "./CustomTableBodyForAllTrackables.styles";

export const renderFieldContent = ({
  field,
  props,
  handleValueChange,
  statusUrl,
  statusList,
  updateRefreshCounter,
}) => {
  switch (field.type) {
    case "int":
      return <CustomStringViewOnly eachfield={field} props={props} />;
    case "dropdown":
      return (
        <CustomDropDown
          eachfield={field}
          props={props}
          handleValueChange={handleValueChange}
        />
      );
    case "string":
      return <CustomStringViewOnly eachfield={field} props={props} />;
    case "DateTimeField":
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        >
          <DateAndTimeViewer dateAndTime={props?.data[field.name]} />
        </div>
      );
    default:
      switch (field.name) {
        case "status":
          return (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
              }}
            >
              <StatusDropDown
                type="small"
                url={statusUrl}
                updateRefreshCounter={updateRefreshCounter}
                statusList={statusList}
                currStatus={props.data.status}
              />
            </div>
          );
        case "task":
          return props.data[field.name] ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
              }}
            >
              <Tooltip
                describeChild
                arrow
                placement="right"
                title={<TaskDetailsOnHover task={props.data.task} />}
                slotProps={{
                  popper: {
                    sx: {
                      "& .MuiTooltip-tooltip": {
                        padding: "0px",
                        backgroundColor: "transparent",
                        border: "none",
                      },
                      "& .MuiTooltip-arrow": {
                        color: "#6C65D9",
                      },
                    },
                  },
                }}
              >
                <Chip
                  sx={{
                    width: "max-content",
                    cursor: "pointer",
                    fontSize: {
                      xs: "8px !important",
                      sm: "10px !important",
                      md: "10px !important",
                      lg: "12px !important",
                      xl: "14px !important",
                    },
                    color: "#f9f9f9 !important",
                    padding: "5px 6px !important",
                  }}
                  size="small"
                  label={props.data.task.name ?? ""}
                  variant="outlined"
                />
              </Tooltip>
            </div>
          ) : (
            <Typography
              sx={{
                fontSize: {
                  xs: "8px !important",
                  sm: "10px !important",
                  md: "10px !important",
                  lg: "12px !important",
                  xl: "14px !important",
                },
              }}
            >
              No Related Task
            </Typography>
          );
        case "created_by":
        case "updated_by":
          if (!props.data[field.name]) {
            return "";
          }
          if (typeof props.data[field.name] === "object") {
            return (
              <Typography
                sx={{
                  textAlign: "left !important",
                  fontSize: {
                    xs: "8px !important",
                    sm: "10px !important",
                    md: "10px !important",
                    lg: "12px !important",
                    xl: "14px !important",
                  },
                }}
              >
                {props.data[field.name]?.first_name || ""}{" "}
                {props.data[field.name]?.last_name || ""}
              </Typography>
            );
          }
          return (
            <Typography
              sx={{
                textAlign: "left !important",
                fontSize: {
                  xs: "8px !important",
                  sm: "10px !important",
                  md: "10px !important",
                  lg: "12px !important",
                  xl: "14px !important",
                },
              }}
            >
              {props.data[field.name]}
            </Typography>
          );
        case "thumbnail":
          return (
            <div>
              {props.data.thumbnail ? (
                <ImageViewer
                  statusUrl={props.data.thumbnail}
                  sliderState={props.shotVersionToggle ? 20 : 0}
                />
              ) : (
                <div style={{ height: "30px", width: "30px" }}>
                  <img src={Img} alt="" height="100%" />
                </div>
              )}
            </div>
          );
        case "shot":
        case "parent_sequence":
          return (
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                fontSize: {
                  xs: "8px !important",
                  sm: "10px !important",
                  md: "10px !important",
                  lg: "12px !important",
                  xl: "14px !important",
                },
              }}
            >
              {props.data[field.name] ? props.data[field.name]?.code : ""}
            </Box>
          );
        case "asset":
          return (
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                fontSize: {
                  xs: "8px !important",
                  sm: "10px !important",
                  md: "10px !important",
                  lg: "12px !important",
                  xl: "14px !important",
                },
              }}
            >
              {props.data[field.name] ? props.data[field.name]?.name : ""}
            </Box>
          );
        case "allowed_dept":
          return (
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                fontSize: {
                  xs: "8px !important",
                  sm: "10px !important",
                  md: "10px !important",
                  lg: "12px !important",
                  xl: "14px !important",
                },
              }}
            >
              {props.data[field.name].length > 0
                ? props.data[field.name].map((dept) => dept.name).join(", ")
                : ""}
            </Box>
          );
        case "duration":
        case "fps":
          return (
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                fontSize: {
                  xs: "8px !important",
                  sm: "10px !important",
                  md: "10px !important",
                  lg: "12px !important",
                  xl: "14px !important",
                },
              }}
            >
              {props.data[field.name] ? props.data[field.name].toFixed(2) : ""}
            </Box>
          );
        default:
          return (
            <Tooltip title={props.data[field.name]}>
              <Typography
                sx={{
                  fontSize: {
                    xs: "8px !important",
                    sm: "10px !important",
                    md: "10px !important",
                    lg: "12px !important",
                    xl: "14px !important",
                  },
                }}
              >
                {props.data[field.name] || ""}
              </Typography>
            </Tooltip>
          );
      }
  }
};

const CustomTableBodyForAllTrackables = ({
  customFields,
  data,
  isMultiSelectEnabled,
  handleSelectItem,
  selectedItems,
  statusUrl,
  statusList,
  updateRefreshCounter,
  customFieldUrl,
}) => {
  const props = { data: data };
  const classes = useStyles();

  const handleValueChange = async (field_name, value) => {
    try {
      const res = await fpatch({
        url: customFieldUrl,
        data: {
          [field_name]: value,
        },
      });
      if (res.status === 200 || res.status === 201) {
        updateRefreshCounter();
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      {isMultiSelectEnabled && (
        <TableCell align="left" className={classes.customTableCell}>
          <Checkbox
            checked={selectedItems.some((item) => data.id === item.id)}
            onClick={handleSelectItem}
            inputProps={{ "aria-label": "controlled" }}
            style={{
              padding: "0",
              minHeight: "0",
            }}
          />
        </TableCell>
      )}
      {customFields?.map((field) => {
        return (
          <TableCell
            key={field.name}
            align="left"
            className={classes.customTableCell}
          >
            {renderFieldContent({
              field,
              props,
              handleValueChange,
              statusUrl,
              statusList,
              updateRefreshCounter,
            })}
          </TableCell>
        );
      })}
    </>
  );
};

export default CustomTableBodyForAllTrackables;

const CustomDropDown = ({ eachfield, props, handleValueChange }) => {
  const classes = useStyles();
  return (
    <FormControl
      size="small"
      style={{
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
      }}
    >
      <Select
        disableUnderline
        className={classes.select}
        value={props.data[eachfield.name]}
        onClick={(e) => e.stopPropagation()}
        onChange={(e) => handleValueChange(eachfield.name, e.target.value)}
      >
        {Object.values(eachfield.options).map((option, index) => (
          <MenuItem
            key={index}
            value={option}
            className={classes.selectMenuItem}
          >
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

const CustomStringViewOnly = ({ eachfield, props }) => {
  return (
    <Tooltip title={props.data[eachfield.name]}>
      <Typography
        sx={{
          textAlign: "left",
          fontSize: {
            xs: "8px !important",
            sm: "10px !important",
            md: "10px !important",
            lg: "12px !important",
            xl: "14px !important",
          },
        }}
      >
        {props.data[eachfield.name]}
      </Typography>
    </Tooltip>
  );
};
